var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['base-scroll-to-top'],on:{"click":_vm.goToTop}},[_c('img',{attrs:{"src":require("../assets/img/svgicons/arrow-up-white-thin.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }